import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setEmployeeProfileDATASActions,
  SetBasiformsID,
  SetIdVeriications,
  SetAddressId,
  setBankDetailsId,
  SetEducationDetails,
  SetPreviousEmployeeID,
  setfamliydetailsid,
  SetDeclarationId,
  SetEsiFormIdActions,
  SetJobOfferID,
  SetCasualActiveTabs,
  getSideBarfilesActions,
  SetApprovalCallsActions,
  settheDateOfjoining,
  setTheOnboardPhoneNumber, //for get the phone number,
  setTheOnboarderdetailsReportActions, /// to get the payroll names,
  sethtmlformatpdfdownoadActions,
  SetTheJoiningDateCall,
  CreateResponse_store,
  setTheSignaturePadNumberSet,
  SETBASICFORMcreatedetails,
  setTheFirstNames,
  setTheActionForOtpPhoneNumbers, ///----Phone---Number----
  setTheActionForOtpwithPhoneNumbers,
  SetSignaturePops,
  settheBankHolderName,
  setTheActionResentForOtpPhoneNumbers,
  settheJobinfoBranchEmployeeProfile,
  setthejobinformationroleID,
  setTheTransactionID,
  setbankCounts,
  settheEmployeeFormFilled, ///---- it  will defined the boolean value , by based it will  make it as edit or not
  gettheRegeneratePdfAction,
  setTheAadharBackSideImageDatas,
  setTHnUMBERSRESPONSES,
  setTheEsignatureCodes,
  setTheAllFormPdf,
  setTablePositionPersist,
  setthe_employee_code_forthe_profile,
  getCasualApproveRequestActionListed,
  setCasualRMApprovalActions,
  gettheCasualOnboardingPdfPreviewAction,
} from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/Management/EmployeeProfile.scss";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pending from "../../../Assets/AppComponent/icons/Group 145.svg";
import ArrowIcons from "../../../Assets/AppComponent/Arrow/Vector .svg";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import { useNavigate, useParams } from "react-router-dom";
import { NavLink } from "react-router-dom";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import emptycircle from "../../../Assets/AppComponent/Ellipse 4.png";
import jsPDF from "jspdf";
import ActiveEmc from "../../../Assets/AppComponent/Group 309.svg";
import InActiveEmc from "../../../Assets/AppComponent/Group 309 (1).svg";

import { toast } from "react-toastify";
import { pdfgetlistapi } from "../../../text/apidata";
import PdfViwers from "./PdfView";
import { faIR } from "date-fns/locale";
import { Label } from "recharts";
// import PdfViewer from "./PdfView";
// import { PDFViewer } from '@react-pdf/renderer';
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import { Button } from "@mui/material";

const CasualApproval = () => {
  const { id } = useParams();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist,
  );
  const Swal = require("sweetalert2");
  //  window.Swal = Swal;
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [UserName, setUserName] = useState("");
  const [RoleName, setRoleNames] = useState("");
  const [EmpActive, setEmpActive] = useState();

  const [Delaration, setDeclarations] = useState();
  const [LastName, setLastName] = useState("");
  const [BasicForm, setBasicForm] = useState();
  const [ESiForm, setEsiForms] = useState();
  const [FamlityDetails, setFamDetails] = useState();
  const [Verify, setVerify] = useState();
  const [PreviouEmp, setPreviEmp] = useState();
  const [Education, setEducation] = useState();
  const [BankDetail, setBankDetail] = useState();
  const [JobOffer, setJobOffer] = useState();
  const [AdderDeatils, setAdderDetails] = useState();
  const navigate = useNavigate();
  const [Approvel, setApprovel] = useState(false);
  const [RMADMIN, setRMADMN] = useState(false);
  const [whatsApp, setWhatsApp] = useState(false);
  const [createEmployee, setCreateEmployee] = useState();
  let payloads = {
    search: "",
    page_size: 10,
    page: 1,
    ids: state.ClientBranchIDs.EmployeeDetailsProfile,
    is_pending: state.ClientBranchIDs.IS_pendingDetails,
  };

  const [open, setopen] = useState(false);
  const UserData = useSelector((state) => state.users.UserData);
  const [SubRoleList, setSubRoleList] = useState();

  const [TabNmaes, setTabnames] = useState({ clientname: "", branchname: "" });
  const [idverificationsID, setdVerifications] = useState(false);

  const [Bank, setBank] = useState(false);
  const [UserImage, setUserimage] = useState(null);

  const [DateOfJoing, setdateOf] = useState();
  const [Onboarder, setOnboader] = useState([]);
  const [Payroll, setpayroll] = useState([]);
  const [Rm, setRm] = useState([]);
  const [token, setTokens] = useState(null);
  const [ManagerList, setManagerList] = useState("");
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [result, setResult] = useState(null); // Define 'result' state

  const [PhonerNumber, setPhoneNumber] = useState();

  const [StatusCode, setStatusCode] = useState(false);
  ///---display the rejoining based in the , approve employee , and when there have the id in the job_description in letter id
  const [RejectionDisplay, setrejectiondisplay] = useState(false);
  const [RejoinBool, setRejoingBool] = useState(false);

  useEffect(() => {
    dispatch(SetSignaturePops(false));
  }, []);

  useEffect(() => {
    const payloads = {
      casual_labour_id: id,
    };
    dispatch(getCasualApproveRequestActionListed(payloads));
  }, [id]);

  useEffect(() => {
    console.log(state.CasualApproveRequestDatas.Inquriy, "djkasdjhasjdjasjkda");
    const responseData = state.CasualApproveRequestDatas.Inquriy;
    setUserName(responseData.first_name);
  }, [state.CasualApproveRequestDatas.Inquriy]);

  ///---rendring the useEffect to find the status
  // useEffect(() => {
  //   if (
  //     state.ManPowerActiveDataTabs.statusCOdeForESign != undefined &&
  //     state.ManPowerActiveDataTabs.statusCOdeForESign != null &&
  //     state.ManPowerActiveDataTabs.statusCOdeForESign == 200
  //   ) {
  //     setStatusCode(true);
  //   } else {
  //     setStatusCode(false);
  //   }
  // }, [state.ManPowerActiveDataTabs.statusCOdeForESign]);

  // console.log(state.NumberCounts.ZONEobjects ,"ZONEobjects" );

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const handlePreviewPdf = () => {
    const payload = {
      id: id
    }
    dispatch(gettheCasualOnboardingPdfPreviewAction(payload))
  }

  const HandleVerify = () => {
    // if(SubRoleList == 0){
    Swal.fire({
      title: "Do you want to  Verify?",
      // text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Verify it!",
    }).then((result) => {
      if (result.isConfirmed) {
        console.log(state.EmployeeProfile.EmployeeProfileList, "userId");
        if (
          state.EmployeeProfile.EmployeeProfileList != undefined ||
          (state.EmployeeProfile.EmployeeProfileList != null &&
            state.EmployeeProfile.EmployeeProfileList.lenght > 0 &&
            state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
            state.EmployeeProfile.EmployeeProfileList.user_id.id != undefined)
        ) {
          const payload = {
            UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
            //is_pending: true,
            is_pending: SubRoleList == 0 ? true : false,
            is_decline: false, ///is_decline :have to be true when the Rm is need to approve
            create_employee: true,
            Decline: 0,
            payroll_approved:
              SubRoleList == 0 || SubRoleList == 3 ? true : true,
          };

          console.log(SubRoleList, "SubRoleList", payload);

          const newEntry_approve = { isApproved: true };
          const result_approve = {
            ...TablePositionPersist.approveRequesTempPage,
            ...newEntry_approve,
          };
          dispatch(
            setTablePositionPersist({
              data: result_approve,
              pageName: "approveRequesTempPage",
            }),
          );

          const newEntry = { isApproved: true };
          const result_dashboard = {
            ...TablePositionPersist.dashBoardOverviewPagecounts,
            ...newEntry,
          };
          dispatch(
            setTablePositionPersist({
              data: result_dashboard,
              pageName: "dashBoardOverviewPagecounts",
            }),
          );

          dispatch(SetApprovalCallsActions(payload));
          if (SubRoleList == 1 || SubRoleList == 3) {
            navigate("/verifystatus");
          } else {
            navigate("/employeeVerifylist");
          }
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };
  // Navigate to esi fomr
  const HandleEnterESI = () => {
    dispatch(SetCasualActiveTabs(9));
    dispatch(
      SetEsiFormIdActions(
        state.EmployeeProfile.EmployeeProfileList.esi_form.id,
      ),
    );
    navigate(`/casualformtab/${id}`);
  };
  // Navigate to esi fomr
  const HandleEnterBasicForm = () => {
    dispatch(SetCasualActiveTabs(1));
    dispatch(
      SetEsiFormIdActions(
        state.EmployeeProfile.EmployeeProfileList.basic_info.id,
      ),
    );
    navigate(`/casualformtab/${id}`);
  };
  const HandleRMpay = () => {
    if (SubRoleList == 1 || SubRoleList == 3) {
      Swal.fire({
        title: "Do you want to verify?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#234492",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes, verify it!",
        // html: `
        //   <div>
        //     <input type="checkbox" id="sendOfferLetter" />
        //     <label for="sendOfferLetter">Send offer letter via WhatsApp</label>
        //   </div>
        // `,
      }).then((result) => {
        if (result.isConfirmed) {
          // const sendOfferLetter = document.getElementById("sendOfferLetter").checked;

          console.log(state.EmployeeProfile.EmployeeProfileList, "userId");
          if (
            state.EmployeeProfile.EmployeeProfileList != undefined ||
            (state.EmployeeProfile.EmployeeProfileList != null &&
              state.EmployeeProfile.EmployeeProfileList.length > 0 &&
              state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
              state.EmployeeProfile.EmployeeProfileList.user_id.id != undefined)
          ) {
            const payload = {
              UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
              is_pending: SubRoleList == 0 ? true : false,
              is_decline: false, // is_decline: have to be true when the RM needs to approve
              create_employee: true,
              Decline: 0,
              payroll_approved:
                SubRoleList == 0 || SubRoleList == 3 ? true : true,
              // send_whatsapp:  sendOfferLetter, // Add the sendOfferLetter state to the payload
              send_whatsapp: false,
              // whatsapp_verify:  sendOfferLetter, // Add the sendOfferLetter state to the payload
              SubRoleList: SubRoleList,
              Ids: state.EmployeeProfile.EmployeeProfileList.user_id.id,
              date: state.NeededdatasListed.dateOfJoing,
            };
            console.log(payload, "27381972payload");

            if (state.SideBarFiles.SideBarFile == "Approve Request") {
              const newEntry = { isApproved: true };
              const result_approve = {
                ...TablePositionPersist.approveRequesTempPage,
                ...newEntry,
              };

              dispatch(
                setTablePositionPersist({
                  data: result_approve,
                  pageName: "approveRequesTempPage",
                }),
              );
            } else if (state.SideBarFiles.SideBarFile == "Overview") {
              const newEntry = { isApproved: true };
              const result_dash = {
                ...TablePositionPersist.dashBoardOverviewPagecounts,
                ...newEntry,
              };
              dispatch(
                setTablePositionPersist({
                  data: result_dash,
                  pageName: "dashBoardOverviewPagecounts",
                }),
              );
            }

            if (!RMADMIN) {
              dispatch(SetApprovalCallsActions(payload));
            } else if (RMADMIN) {
              const payload = {
                UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
                is_pending: SubRoleList == 0 ? true : false,
                is_decline: false, // is_decline: have to be true when the RM needs to approve
                create_employee: true,
                Decline: 0,
                payroll_approved:
                  SubRoleList == 0 || SubRoleList == 3 ? true : true,
                // send_whatsapp:  sendOfferLetter, // Add the sendOfferLetter state to the payload
                send_whatsapp: false,
                SubRoleList: SubRoleList,
                Ids: state.EmployeeProfile.EmployeeProfileList.user_id.id,
                date: state.NeededdatasListed.dateOfJoing,
              };
              dispatch(SetTheJoiningDateCall(payload));
              //  navigate("/employeeprofile");
            }
            //  dispatch(SetTheJoiningDateCall(payload))

            // if (SubRoleList == 1 || SubRoleList == 3) {
            //   navigate("/verifystatus");
            // } else {
            //   navigate("/employeeVerifylist");
            // }
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
      });
    }
  };

  ////------------------Declines-------------------------
  const HandleDecline = () => {
    Swal.fire({
      title: "Do you want to Reject?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Reject it!",
      input: "text",
      inputPlaceholder: "Reason for reject...",
      inputAttributes: {
        style:
          "text-align: left; width: 90%; margin: auto; display: block;margin-top: 10px;",
      },
      inputValidator: (value) => {
        if (!value) {
          return "You need to provide a reason for rejecting";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // const payload = {
        //   UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
        //   is_pending: true,
        //   is_decline: true,
        //   // is_pending: false,
        //   //  create_employee: false,
        //   Decline: 1,
        //   payroll_approved: SubRoleList == 0 ? false : false,
        // };

        console.log(result, "pduaposdasd result");

        const reason = result.value; // Retrieve the value entered by the user
        const payload = {
          UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
          is_pending: true,
          is_decline: true,
          Decline: 1,
          payroll_approved: false,
          reason_for_decline: reason, // Include the reason in the payload
        };
        // console.log(payload , "payload");
        const newEntry_approve = { isApproved: true };
        const result_approve = {
          ...TablePositionPersist.approveRequesTempPage,
          ...newEntry_approve,
        };
        dispatch(
          setTablePositionPersist({
            data: result_approve,
            pageName: "approveRequesTempPage",
          }),
        );

        const newEntry = { isApproved: true };
        const result_dash = {
          ...TablePositionPersist.dashBoardOverviewPagecounts,
          ...newEntry,
        };
        dispatch(
          setTablePositionPersist({
            data: result_dash,
            pageName: "dashBoardOverviewPagecounts",
          }),
        );

        const newEntry_onboard = { isApproved: true };
        const result_onboard = {
          ...TablePositionPersist.fieldagentPage,
          ...newEntry_onboard,
        };

        dispatch(
          setTablePositionPersist({
            data: result_onboard,
            pageName: "fieldagentPage",
          }),
        );

        const newEntry_my = { isApproved: true };
        const result_my_oboarding = {
          ...TablePositionPersist.MyonboardingTempPage,
          ...newEntry_my,
        };

        dispatch(
          setTablePositionPersist({
            data: result_my_oboarding,
            pageName: "MyonboardingTempPage",
          }),
        );

        dispatch(SetApprovalCallsActions(payload));
        // DateOfJoing
        navigate("/approverequestemp");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          text: " Employee verification as been cancel",
          icon: "error",
        });
        Swal.close();
      }
    });
  };

  //  console.log(state.ClientBranchIDs.SUBROLE , "SUBROLE");

  // const fetchPdf = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(
  //       pdfgetlistapi + state.ClientBranchIDs.EmployeeDetailsProfile + "/",
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     console.log(response, "response");
  //     if (!response.ok) {
  //       throw new Error("Network response was not ok");
  //     }
  //     const pdfBlob = await response.blob();
  //     const url = URL.createObjectURL(pdfBlob);
  //     setPdfUrl(url);
  //   } catch (error) {
  //     console.error("Error fetching PDF:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  console.log(
    state.NumberCounts.AllFormPDF,
    "asudpoasidoas dstate.NumberCounts.AllFormPDF",
  );

  useEffect(() => {
    if (
      state.ManPowerActiveDataTabs.statusCOdeForESign !== undefined &&
      state.ManPowerActiveDataTabs.statusCOdeForESign !== null &&
      state.ManPowerActiveDataTabs.statusCOdeForESign === 200 &&
      // &&
      // StatusCode
      result
    ) {
      if (PhonerNumber != undefined) {
        handleSwalFire(result);
      }
    }
  }, [state.ManPowerActiveDataTabs.statusCOdeForESign, result]);

  var PhoneNumberForOtp;
  //---have to check the signature with the phone number fileds-----------
  const HandleCreateEmployee = () => {
    const inputValue =
      state.EmployeeVerificationsNeed.OnborderPhoneNumber != undefined &&
        state.EmployeeVerificationsNeed.OnborderPhoneNumber != null
        ? state.EmployeeVerificationsNeed.OnborderPhoneNumber
        : "";

    Swal.fire({
      title: "Please enter your phone number",
      input: "number",
      inputPlaceholder: "Phone Number",
      inputAttributes: {
        min: 0,
        max: 10,
      },
      allowOutsideClick: false,
      inputValue,
      // allowOutsideClick: true, // Allow closing the popup by clicking outside

      inputValidator: (value) => {
        if (!value) {
          return "Phone number is required";
        }
        if (value.length > 10) {
          return "Phone number cannot be longer than 10 digits";
        }
        if (value.length < 10) {
          return "Phone number cannot be Less than 10 digits";
        }
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",

      inputClass: "custom-inputField", // Add a custom
      customClass: {
        popup: "phone-input-popup",
        input: "phone-input-field",
      },
      preConfirm: (phone) => {
        // Here you can handle the submission of the phone number
        PhoneNumberForOtp = phone;
        console.log(PhoneNumberForOtp, "PhoneNumberForOtp");
        const payload = {
          phone_number: phone,
        };

        setPhoneNumber(phone);
        const newEntry_approve = { isApproved: true };
        const result_approve = {
          ...TablePositionPersist.approveRequesTempPage,
          ...newEntry_approve,
        };
        dispatch(
          setTablePositionPersist({
            data: result_approve,
            pageName: "approveRequesTempPage",
          }),
        );

        const newEntry_onboard = { isApproved: true };
        const result_onboard = {
          ...TablePositionPersist.fieldagentPage,
          ...newEntry_onboard,
        };

        dispatch(
          setTablePositionPersist({
            data: result_onboard,
            pageName: "fieldagentPage",
          }),
        );

        const newEntry_my = { isApproved: true };
        const result_my_oboarding = {
          ...TablePositionPersist.MyonboardingTempPage,
          ...newEntry_my,
        };

        dispatch(
          setTablePositionPersist({
            data: result_my_oboarding,
            pageName: "MyonboardingTempPage",
          }),
        );

        //console.log("PhoneNum6876687ber:", phone, PhonerNumber);
        dispatch(setTheActionForOtpPhoneNumbers(payload)); ///--- for the  --phone number

        return new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, 2000); // Simulating server request delay
        });
      },
      // allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      setResult(result); // Set 'result' state here
      if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          text: "Employee verification has been cancelled",
          icon: "error",
        });
        dispatch(setTheEsignatureCodes(502)); //for close the otp

        Swal.close();
      }
    });
  };

  function handleSwalFire(result) {
    if (result) {
      const timerDuration = 60;
      let timeLeft = timerDuration;
      function formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const secondsRemaining = seconds % 60;
        return `${minutes}:${secondsRemaining < 10 ? "0" : ""}${secondsRemaining}`;
      }
      Swal.fire({
        title: "Please enter the OTP sent to your phone",
        html: `
<div id="otp-container" style="display: flex; flex-direction: column; gap: 10px;">
  <div id="timer">Time remaining: <span id="timer-count">${formatTime(timeLeft)}</span></div>
  <div style="display: flex; gap: 10px;">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp1">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp2">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp3">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp4">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp5">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp6">
  </div>
</div>

        <button id="resend-otp" style="display:none;padding:10px;border-radius:4px;background:rgb(246, 147, 56);color:white">Resend OTP</button>
      `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Verify",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        confirmButtonColor: "#234492",
        cancelButtonColor: "#6c757d",
        didOpen: () => {
          const inputs = document.querySelectorAll(".swal2-input");
          const timerCountElement = document.getElementById("timer-count");
          const resendButton = document.getElementById("resend-otp");
          const verifyButton = Swal.getConfirmButton();
          verifyButton.disabled = true; // Disable the button initially

          inputs.forEach((input, index) => {
            input.dataset.index = index;
            input.addEventListener("keyup", handleOtp);
            input.addEventListener("input", handleNumericInput);

            input.addEventListener("paste", handleOnPasteOtp);
          });
          document
            .getElementById("resend-otp")
            .addEventListener("click", handleResendOtp);

          function handleOtp(e) {
            const input = e.target;
            let value = input.value;
            let isValidInput = value.match(/[0-9a-z]/gi);
            input.value = isValidInput ? value[0] : "";
            let fieldIndex = input.dataset.index;

            if (fieldIndex < inputs.length - 2 && isValidInput) {
              input.nextElementSibling.focus();
            }
            if (e.key === "Backspace" && fieldIndex > 0) {
              input.previousElementSibling.focus();
            }
            if (fieldIndex == inputs.length - 2 && isValidInput) {
              submit();
            }
          }

          function handleNumericInput(e) {
            e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove any non-numeric characters
          }

          function handleOnPasteOtp(e) {
            const data = e.clipboardData.getData("text");
            const value = data.split("");
            if (value.length === inputs.length) {
              inputs.forEach((input, index) => (input.value = value[index]));
              submit();
            }
          }

          function submit() {
            let otp = "";
            inputs.forEach((input) => {
              otp += input.value;
            });

            // Define and dispatch the action
            const payload = {
              otp: {
                phone_number: PhonerNumber,
                otp: otp,
              },
              Funcations: () => {
                // Your function logic here
                Swal.close();
              },
            };
            dispatch(setTheActionForOtpwithPhoneNumbers(payload));
          }

          function updateTimer() {
            timeLeft--;
            timerCountElement.textContent = formatTime(timeLeft);
            if (timeLeft <= 0) {
              clearInterval(timerInterval);
              // Optionally disable inputs and show resend button
              inputs.forEach((input) => (input.disabled = true));
              resendButton.style.display = "inline-block";
              resendButton.addEventListener("click", handleResendOtp);
            }
          }

          let timerInterval = setInterval(updateTimer, 1000);

          function handleResendOtp() {
            // Implement OTP resend logic here
            // console.log('Resend OTP logic here');
            // You may also want to reset the timer here
            const payload = {
              phone_number: PhonerNumber,
            };

            //console.log("PhoneNum6876687ber:", phone, PhonerNumber);
            dispatch(setTheActionResentForOtpPhoneNumbers(payload)); ///--- for the  --phone number

            // // Clear the input values
            // inputs.forEach((input) => {
            //   input.value = "";
            //   input.disabled = false; // Ensure inputs are enabled
            //   input.classList.remove("disabled"); // Remove disabled class if any
            // });

            // // Reset the timer if needed
            // timeLeft = 50; // Example of resetting the timer to 5 minutes
            // document.getElementById("timer-count").textContent = formatTime(timeLeft);

            // Clear the input values
            inputs.forEach((input) => {
              input.value = "";
              input.disabled = false; // Ensure inputs are enabled
              input.classList.remove("disabled"); // Remove disabled class if any
            });

            // Clear existing timer interval
            if (timerInterval) {
              clearInterval(timerInterval);
            }

            // Reset the timer
            timeLeft = 60; // Reset timer to 10 seconds or your preferred value
            const timerElement = document.getElementById("timer-count");

            if (timerElement) {
              timerElement.textContent = formatTime(timeLeft);
              //  console.log(timerElement , "938wudjtimerElement");
            } else {
              console.error("Timer element not found");
            }

            // Start the timer again
            timerInterval = setInterval(() => {
              if (timeLeft <= 0) {
                clearInterval(timerInterval);
                console.log("OTP timer expired");
              } else {
                timeLeft -= 1;
                if (timerElement) {
                  timerElement.textContent = formatTime(timeLeft);
                  console.log(
                    timerElement.textContent,
                    "timerElement",
                    timerElement.textContent == "0:00",
                  );
                  if (timerElement.textContent == "0:00") {
                    resendButton.style.display = "inline-block";
                  }
                } else {
                  console.error("Timer element not found");
                }
              }
            }, 1000);

            resendButton.style.display = "none";
          }
        },
      });
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      dispatch(setTheEsignatureCodes(502)); //for close the otp
      Swal.fire({
        text: "Employee verification has been cancelled",
        icon: "error",
      });

      Swal.close();
    }
  }

  useEffect(() => {
    dispatch(setTheSignaturePadNumberSet(0));
  }, []);

  // useEffect(() => {
  //   if (
  //     state.NumberCounts.Editable == 1 &&
  //     state.ClientBranchIDs.ApproveRequest == 2
  //   ) {
  //     dispatch(getSideBarfilesActions("Approve Request"));
  //   }
  //   if (
  //     state.NumberCounts.Editable == 2 &&
  //     state.ClientBranchIDs.ApproveRequest == 4
  //   ) {
  //     dispatch(getSideBarfilesActions("Onboarding"));
  //   }
  //   if (
  //     state.NumberCounts.Editable == 2 &&
  //     state.ClientBranchIDs.ApproveRequest == 5
  //   ) {
  //     dispatch(getSideBarfilesActions("My Onboarding List"));
  //   }

  //   if (
  //     // state.NumberCounts.Editable == 2 &&
  //     state.ClientBranchIDs.ApproveRequest == 3
  //   ) {
  //     dispatch(getSideBarfilesActions("Client"));
  //   }

  //   if (
  //     state.NumberCounts.Editable == 1 &&
  //     state.ClientBranchIDs.ApproveRequest == 6
  //   ) {
  //     dispatch(getSideBarfilesActions("Overview"));
  //   }

  //   if (
  //     state.NumberCounts.Editable == 1 &&
  //     state.ClientBranchIDs.ApproveRequest == 7
  //   ) {
  //     dispatch(getSideBarfilesActions("Onboard Overview"));
  //   }
  // }, [
  //   state.NumberCounts.Editable,
  //   state.SideBarFiles.SideBarFile,
  //   state.ClientBranchIDs.ApproveRequest,
  // ]);

  const handleApproveRM = () => {
    Swal.fire({
      title: "Do you want to approve this request ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Approve",
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          id: id,
        };

        dispatch(setCasualRMApprovalActions(payload));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  console.log(
    "Basic_gender_datas supdoasid",
    state.NumberCounts.BranchObjectJobInfoFieldAgent,
  );

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-12 auto"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "flex-start",
            }}
          >
            <h3>Employee Profile </h3>
            <Button
              className="btn doctorupload"
              variant="contained"
              component="label"
              style={{
                background: "#234492",
                color: "#fff",
                fontSize: "11px !important",
                marginLeft: "12px",
              }}
              onClick={handlePreviewPdf}
            >Preview</Button>
          </div>

        </div>

        <br />

        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",

            marginLeft: "0px",
            marginRight: "0px",
            top: "-46px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                navigate("/casualonboarding");
              }}
            >
              <img className="PreviousPages" src={BackImage} />
              <span></span>
            </button>
          </div>

        </div>

        <div className="Header-Details EmployeeProfileHeaders">
          <div className="InnerDetails">
            <div className="InnerDetailPart">
              <div className="LOGO">
                {UserImage != null ? (
                  <img src={UserImage} />
                ) : (
                  <img src={profile2} />
                )}
              </div>
              <p className="EMpCODER">
                <span style={{ textTransform: "captilize" }}>{UserName}</span>
                {/* <span>
                  <>
                    {" "}
                    Emp Code :{" "}
                    <span>{RoleName != "" ? <>{RoleName}</> : <>--</>}</span>
                  </>
                </span> */}
              </p>
            </div>


          </div>
        </div>

        <div className="row EmpPorfile">
          {/* -------------------------------Forms---------------------------------- */}

          {/* -------------------__Basic----Forms---------------------------------------- */}

          {/* {state.EmployeeProfile.EmployeeProfileList != undefined && */}
          {/* state.EmployeeProfile.EmployeeProfileList.basic_info != undefined && */}
          {/* state.EmployeeProfile.EmployeeProfileList.basic_info.id != */}
          {/* undefined ? ( */}
          <>
            {/* {state.EmployeeProfile.EmployeeProfileList.map((item) => ( */}
            <div
              className="col-md-3 Cards"
              id="ex3-tab-1"
              onClick={(e) => {
                navigate(`/casualformtab/${id}`);
                dispatch(SetCasualActiveTabs(1));
              }}
            >
              <div className="card">
                <div className="card-body EmployeeCardBody">
                  <div className="WIthPendingStatus">
                    <h5>Basic Information</h5>

                    {/* <div className="ICONS">
                      <img
                        src={
                          BasicForm
                            ? correctIcons
                            : state.EmployeeProfile.EmployeeProfileList == ""
                              ? emptycircle
                              : Pending
                        }
                      />
                      <img src={ArrowIcons} />
                    </div> */}
                  </div>

                  <p>Personal information & Other Details</p>
                </div>
              </div>
            </div>
          </>
          <>
            <div
              className="col-md-3 tab-pane  Cards"
              id="ex3-tabs-2"
              onClick={(e) => {
                // console.log(
                //   state.EmployeeProfile.EmployeeProfileList.address_details,
                //   "szczx detailss"
                // );
                dispatch(SetCasualActiveTabs(2));

                navigate(`/casualformtab/${id}`);
              }}
            >
              <div className="card">
                <div className="card-body EmployeeCardBody">
                  <div className="WIthPendingStatus">
                    <h5>Address Details </h5>

                    {/* <div className="ICONS">
                      <img
                        src={
                          AdderDeatils
                            ? correctIcons
                            : state.EmployeeProfile.EmployeeProfileList == ""
                              ? ""
                              : Pending
                        }
                      />
                      <img src={ArrowIcons} />
                    </div> */}
                  </div>

                  <p>Current & Permanent Address Details</p>
                </div>
              </div>
            </div>
          </>
          {/* ) : null}  */}

          {/* ------------------__JOB-------OFFERS----------------------------------- */}
          <div
            className="col-md-3 Cards"
            disabled={
              state.EmployeeProfile.EmployeeProfileList == null &&
              state.EmployeeProfile.EmployeeProfileList == ""
            }
            onClick={(e) => {
              navigate(`/casualformtab/${id}`);

              dispatch(SetCasualActiveTabs(3));
            }}
          >
            <div className="card">
              <div className="card-body EmployeeCardBody">
                <div className="WIthPendingStatus">
                  <h5>Job Information</h5>
                  {/* <div className="ICONS">
                    <img
                      src={
                        JobOffer
                          ? correctIcons
                          : state.EmployeeProfile.EmployeeProfileList == ""
                            ? ""
                            : Pending
                      }
                    />
                    <img src={ArrowIcons} />
                  </div> */}
                </div>
                <p>Enter Your Job Information Details </p>
              </div>
            </div>
          </div>

          {/* ------------------BANK----------Details--------------------------------- */}
          <div
            className="col-md-3 Cards"
            disabled={
              state.EmployeeProfile.EmployeeProfileList.bank_details == null
            }
            onClick={(e) => {
              navigate(`/casualformtab/${id}`);

              dispatch(SetCasualActiveTabs(4));
            }}
          >
            <div className="card">
              <div className="card-body EmployeeCardBody">
                <div className="WIthPendingStatus">
                  <h5>Bank Details</h5>
                  {/* <div className="ICONS">
                    <img
                      src={
                        BankDetail
                          ? correctIcons
                          : state.EmployeeProfile.EmployeeProfileList == ""
                            ? ""
                            : Pending
                      }
                    />
                    <img src={ArrowIcons} />
                  </div> */}
                </div>
                <p>Account Number and IFSC Code Details</p>
              </div>
            </div>
          </div>

          <div
            className="col-md-3 Cards"
            onClick={(e) => {
              navigate(`/casualformtab/${id}`);

              dispatch(SetCasualActiveTabs(5));
            }}
          >
            <div
              onClick={(e) => {
                navigate(`/casualformtab/${id}`);

                dispatch(SetCasualActiveTabs(5));
              }}
            >
              <div className="card">
                <div className="card-body EmployeeCardBody">
                  <div className="WIthPendingStatus">
                    <h5>Family Details</h5>
                    {/* <div className="ICONS">
                      <img
                        src={
                          FamlityDetails
                            ? correctIcons
                            : state.EmployeeProfile.EmployeeProfileList == ""
                              ? ""
                              : Pending
                        }
                      />
                      <img src={ArrowIcons} />
                    </div> */}
                  </div>
                  <p>Enter Your Family Details</p>
                </div>
              </div>
            </div>
          </div>

          {/* -------Refernces----- */}
          <div
            className="col-md-3 Cards"
            onClick={(e) => {
              navigate(`/casualformtab/${id}`);

              dispatch(SetCasualActiveTabs(6));
            }}
          >
            <div className="card">
              <div
                className="card-body EmployeeCardBody"
                onClick={(e) => {
                  navigate("/supportdocuments");
                }}
              >
                <div className="WIthPendingStatus">
                  <h5>References</h5>
                  {/* <div className="ICONS">
                    <img src={ArrowIcons} />
                  </div> */}
                </div>
                <p> References </p>
              </div>
            </div>
          </div>

          <>
            <div className="col-12 Filters CardDetailsOFOnboard">
              <h3>Onboard Details </h3>
            </div>


            <>
              <div
                className="col-md-3 Cards"
                disabled={true}
                style={{ cursor: "not-allowed" }}
              >
                <div className="card onboardingCards">
                  <div
                    className={`card-body  OnboardCardDetails  ${Onboarder.length > 1 ? "ForScroll" : ""}`}
                  >
                    <span className="OnboardeHeader">Onboard</span>

                    {state.CasualApproveRequestDatas.Inquriy?.onboard_approved_by != null ? (

                      <>
                        <div className="EachPayroll">
                          <h5>
                            <span>Name : </span>
                            {capitalizeFirstLetter(state.CasualApproveRequestDatas.Inquriy.onboard_approved_by.first_name)}
                            {" "}
                            {capitalizeFirstLetter(state.CasualApproveRequestDatas.Inquriy.onboard_approved_by.last_name)}
                          </h5>
                          {/* <h5>
                                <span>Status : </span>
                                {capitalizeFirstLetter(item.status)}
                              </h5> */}

                          <h5>
                            <span>Date : </span>
                            {
                              (() => {
                                const date = new Date(
                                  state.CasualApproveRequestDatas.Inquriy?.onboarder_approved_date
                                );

                                const formattedDate = `${String(date.getDate()).padStart(2, "0")}-${String(
                                  date.getMonth() + 1
                                ).padStart(2, "0")}-${date.getFullYear()}`;

                                const formattedTime = date.toLocaleTimeString("en-IN", {
                                  hour: "numeric",
                                  minute: "2-digit",
                                  hour12: true,
                                });

                                return `${formattedDate} - ${formattedTime}`;
                              })()
                            }
                          </h5>
                        </div>
                      </>

                    ) : (
                      <>
                        <div className="EachPayroll text-center">
                          <p>Awaiting for Onboard</p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div
                className="col-md-3 Cards"
                disabled={true}
                style={{ cursor: "not-allowed" }}
              >
                <div className="card onboardingCards">
                  <div
                    className={`card-body  OnboardCardDetails  ${Rm.length > 1 ? "ForScroll" : ""}`}
                  >
                    <span className="OnboardeHeader">RM</span>
                    <>
                      {state.CasualApproveRequestDatas.Inquriy.kyc_verified_date != null ? (
                        <>

                          <div className="EachPayroll">
                            <h5>
                              <span>Name : </span>
                              {capitalizeFirstLetter(state.CasualApproveRequestDatas.Inquriy.kyc_verified_by?.first_name)}
                              {capitalizeFirstLetter(state.CasualApproveRequestDatas.Inquriy.kyc_verified_by?.last_name)}
                            </h5>

                            <h5>
                              <span>Date : </span>
                              {(() => {
                                const date = new Date(
                                  state.CasualApproveRequestDatas.Inquriy?.kyc_verified_date
                                );

                                const formattedDate = `${String(date.getDate()).padStart(2, "0")}-${String(
                                  date.getMonth() + 1
                                ).padStart(2, "0")}-${date.getFullYear()}`;

                                const formattedTime = date.toLocaleTimeString("en-IN", {
                                  hour: "numeric",
                                  minute: "2-digit",
                                  hour12: true,
                                });

                                return `${formattedDate} - ${formattedTime}`;
                              })()}
                            </h5>
                          </div>
                        </>

                      ) : (
                        <>
                          <div className="EachPayroll text-center">
                            <p>Awaiting for RM</p>
                          </div>
                        </>
                      )}
                    </>
                  </div>
                </div>
              </div>
            </>

          </>



        </div>
        <>
          {state.CasualApproveRequestDatas.Inquriy?.is_pending&&state.CasualApproveRequestDatas.Inquriy?.create_employee &&
            <div
              className="col-12 VerficationStatus"
              style={{
                marginTop: "90px",
                marginBottom: "20px",
              }}
            >

              <button
                className="verify ButtonCSS"
                onClick={handleApproveRM}

              >
                Approve
              </button>
            </div>}
          {!state.CasualApproveRequestDatas.Inquriy?.is_pending &&
            <div
              className="col-12 VerficationStatus"
              style={{
                marginTop: "90px",
                marginBottom: "20px",
              }}
            >

              <button
                className="verify ButtonCSS"
                // onClick={handleApproveRM}

              >
                Approved
              </button>
            </div>}
        </>
      </div>
      gdhhf hb hj  hj hj jhkh ghjhhhjk

      {open ? (
        // && state.pdfdownloadcall.PdfDownloadDatas !=""
        <PdfViwers
          token={token}
          show={open}
          setshow={setopen}
          pdfUrl={state.pdfdownloadcall.PdfDownloadDatas}
          SubRoleList={SubRoleList}
          Approvel={Approvel}
          createEmployee={createEmployee}
        />
      ) : null}
    </>
  );
};

export default CasualApproval;
